/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Column } from '@g17eco/molecules/tracking-list';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { Answer } from '../../types';
import { Badge } from 'reactstrap';

interface ColumnApprovedProps extends Pick<ColumnCommonProps, 'question' | 'alternativeCode' | 'preferredAltCodes'> {
  answer?: Answer;
}

export const ColumnApproved = (props: ColumnApprovedProps) => {
const { answer } = props;

  if (!answer || answer.status !== 'completed') {
    return null;
  }
  const needsApproval = Boolean(
    answer.status === 'completed' &&
      answer.confidence &&
      answer.confidence < 90 &&
      !answer.approved,
  );
  return (
    <Column {...props}>
      <div className='d-flex align-items-center gap-2 mb-1'>
        {answer.approved && <Badge className='bg-success text-white small'>Approved</Badge>}
        {needsApproval && (
          <Badge className='bg-warning text-dark small'>
            <i className='fal fa-exclamation-triangle me-1' />
            Needs Review
          </Badge>
        )}
      </div>
    </Column>
  );
}
